import router, { IRoute, IRouteParams } from '../../../base/lib/router'
import { Div } from '../../../base/components/native/div'
import { waitFor } from '../../../base/utils/wait'
import { HomeHeader } from './home-header'
import helpers from '../../../helpers'
import api from '../../../services/api'
import { MainTitle } from './main-title'
import { MainInput } from './main-input'
import { NotSure } from './not-sure'
import { HowItWorks } from './how-it-works/how-it-works'
import { Inspiration } from './inspiration/inspiration'
import { FAQs } from './faqs/faqs'
import { Footer } from './footer/footer'
import { Loading } from './loading'
import { Preview } from './preview'
import { ProductBlock } from './product-block/product-block'
import { Assistant } from './assistant/assistant'
import state from '../../../base/services/state'
import { MenuIcon } from '../../shared/menu-icon/menu-icon'
import db from '../../../services/db'
import ldb from '../../../base/lib/ldb'
import services from '../../../services'
import device from '../../../base/helpers/device'
import { shortUUID } from '../../../base/utils/id-generator'
import models from '../../../models'

export const HomePage = () => {
    const [getDesign, setDesign] = state.use<any>('design')
    const [getProducts, setProducts] = state.use<any>('products')
    const base = Div()
    const header = HomeHeader()
    const menuIcon = MenuIcon()
    const title = MainTitle()
    const input = MainInput()
    const notSure = NotSure()
    const assistant = Assistant()
    const loading = Loading()
    const preview = Preview()
    const products = ProductBlock()
    const howItWorks = HowItWorks()
    // const ourProducts = OurProducts()
    const inspiration = Inspiration()
    const faq = FAQs()
    const footer = Footer()
    // const buttons = ConfirmButtons()
    base.append(header, menuIcon,  title, input, notSure, assistant, loading, preview, products, howItWorks, inspiration, faq, footer)
    products.render()
    let mode = 'input'
    input.on('submit', async (value: string) => {
        mode = 'input'
        await handleUsage()
        await handleSubmit(value)
    })
    assistant.on('submit', async (value: string) => {
        mode = 'assistant'
        await handleUsage()
        await handleSubmit(value)
        
    })

    async function handleSubmit(value: string) {
        loading.style({ display: 'flex', paddingTop: '300px' })
        loading.load()
        loading.el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        const results = await api.post('/api/images/generate', { prompt: value , mode})
        const ursl = results.map((r: any) => location.origin +  '/api/images/designs/'  + r.split('/').pop())
        const history = models.history.create(value, ursl, mode)
        services.history.save(history) 
        preview.style({ display: 'flex' })
        preview.fill(ursl)
        loading.style({ display: 'none' })
        preview.el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        const products = await services.products.get()
        setProducts(products)
    }

    async function handleUsage() {
        const usage = await  db.find('general', { index: 'key', value: 'current-usage' })
        const currentUsage = usage[0].value
        await db.update('general', usage[0].id, { ...usage[0], value: currentUsage + 1 })
        if (currentUsage > 10 && !ldb.get('ai-art-user')) {
            router.goto('/login')
        }
    }
    preview.on('start-again', () => {
        if (mode === 'input') {
            preview.style({ display: 'none' })
            input.style({ display: 'flex' })
        } else {
            preview.style({ display: 'none' })
            // assistant.style({ display: 'flex' })
            assistant.tryAgain()
        }
    })
    preview.on('ready', async () => {
        await waitFor(300)
        products.render()
        products.el.scrollIntoView({ behavior: 'smooth', block: 'end' })
    })
    notSure.el.onclick = () => {
        assistant.style({ display: 'block' })
        notSure.style({ display: 'none' })
        input.style({ display: 'none' })
        assistant.el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
    assistant.on('close', () => {
        assistant.style({ display: 'none' })
        notSure.style({ display: 'block' })
        input.style({ display: 'flex' })
        input.el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    })

    base.cssClass(helpers.styles.PAGE_BASE_STYLE)

    function exit({ to = '' }: IRouteParams) {
        base.style(helpers.styles.PAGE_EXIT_UP_STYLE)
    }

    async function enter({ query, from, to, data }: IRouteParams) {
        if (device.isMobile()) await waitFor(200)
        base.style(helpers.styles.PAGE_ENTER_STYLE)
    }

    return Object.assign(base, { enter, exit })
}